module.exports = __webpack_public_path__ + "a8a10a3e/img/search-filter-icon.c4751a52.svg";